import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import TimeOffTransactions from './TimeOffTransactions';
import UserTimeOffSettings from './UserTimeOffSettings';
import YearEndRollover from './YearEndRollover';

const TimeOffPage = () => {
  const history = useHistory();
  const location = useLocation();
  
  // Determine active tab based on current route
  const getActiveTab = () => {
    if (location.pathname.includes('settings')) {
      return 'settings';
    }
    if (location.pathname.includes('rollover')) {
      return 'rollover';
    }
    // Default to balances
    return 'balances';
  };

  const [activeTab, setActiveTab] = useState(getActiveTab());

  // Update active tab when route changes
  useEffect(() => {
    if (location.pathname.includes('settings')) {
      setActiveTab('settings');
    } else if (location.pathname.includes('rollover')) {
      setActiveTab('rollover');
    } else {
      setActiveTab('balances');
    }
  }, [location.pathname]);

  const handleTabChange = (key: string) => {
    setActiveTab(key);
    // Update URL based on selected tab
    switch (key) {
      case 'settings':
        history.push('/human-resources/time-off/settings');
        break;
      case 'rollover':
        history.push('/human-resources/time-off/rollover');
        break;
      case 'balances':
      default:
        history.push('/human-resources/time-off/balances');
        break;
    }
  };

  return (
    <div className="flex flex-col h-full bg-white p-4 rounded-md">
      {/* @ts-ignore - React type conflict between frontend and backend node_modules */}
      <Tabs activeKey={activeTab} onChange={handleTabChange}>
        {/* @ts-ignore - React type conflict between frontend and backend node_modules */}
        <Tabs.TabPane tab="Time Off Balances" key="balances">
          <TimeOffTransactions allowAdd />
        </Tabs.TabPane>
        {/* @ts-ignore - React type conflict between frontend and backend node_modules */}
        <Tabs.TabPane tab="Time Off Settings" key="settings">
          <UserTimeOffSettings />
        </Tabs.TabPane>
        {/* @ts-ignore - React type conflict between frontend and backend node_modules */}
        <Tabs.TabPane tab="Year-End Rollover" key="rollover">
          <YearEndRollover />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default TimeOffPage;
